import "./global.css";

import { initTheme } from "@/lib/theme";

initTheme();

import { Toaster } from "@/shadcn/toaster";
import { createRoot } from "react-dom/client";
import { Toaster as Sonner } from "@/shadcn/sonner";
import { TooltipProvider } from "@/shadcn/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { AuthProvider } from "@/auth/AuthProvider";
import { PrivateRoute } from "@/auth/PrivateRoute";
import { AppRouter } from "@/routes/AppRouter";
import { PublicRouter } from "./pages/public/PublicRouter";
import { VoiceRouter } from "./pages/public/voice/VoiceRouter";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            {/* Root redirects into the monitoring dashboard */}
            <Route
              path="/"
              element={<Navigate to="/monitoring/dashboard" replace />}
            />

            {/* Public routes (no authentication required) */}
            <Route path="/public/*" element={<PublicRouter />} />

            {/* Caller-facing voice-auth flow — short SMS-friendly URLs.
                Mixes public (magic-link token) + session-authed sub-routes;
                gating is handled inside VoiceRouter. */}
            <Route path="/voice/*" element={<VoiceRouter />} />

            {/* Authenticated app — single shell, flat router */}
            <Route element={<PrivateRoute />}>
              <Route path="/*" element={<AppRouter />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");
createRoot(rootElement).render(<App />);
